






































































import {Component, Mixins, Prop, Vue} from 'vue-property-decorator'
import Cookies from 'js-cookie'
import storeMixin from '@/utils/storeMixin';
import _ from 'lodash'
import {wt} from '@/api'
import { AppModule } from '@/store/modules/app'

@Component({
  name: 'wtEdit',
  components: { }
})
export default class extends Mixins(storeMixin) {
  public $refs!: {}

  @Prop({type: Object, default: () => {return {}}}) private W_query!: any

  private formData: any = {
    Account: "",
    AppName: "",
    DataIsolateOptionalInfo: {},
    LanguageName: "",
    Password: "",
    Remember: false,
    TenantName: "wingtech",
    Token: "",
  };
  private isLoading:any = false
  private wrong:any = {
    userWrong: false,
    pwdWrong: false,
    tnWrong: false
  }
  private routeLink:any = ''
  private langData:any = [
    {
      name: '中文',
      value: 'zh-cn'
    },{
      name: 'EN',
      value: 'en-us'
    },
  ]

  async created() {
    // this.$router.push({query:{path:'http://192.168.0.78:8001/MainSystem?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9zaWQiOiIxIiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvbmFtZWlkZW50aWZpZXIiOiIxIiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvbmFtZSI6IkFkbWluIiwianRpIjoiMCIsImF1dGhfdGltZSI6IjE2MjAzNTA5NTg1ODciLCJpc3MiOiJXaW5ndGVjaC5PcGVuTWVzIiwiYXVkIjoid3IifQ.pYQw8U6XIz3EVXsVcER8S10zTUazeThQGs2GC58vjfY'}})
    if(Cookies.get('loginPwd')&&Cookies.get('userName')){
      this.formData.Remember = true
      this.formData.Account = Cookies.get('userName')
      this.formData.Password = Cookies.get('loginPwd')
    }
    else{
      this.formData.Remember = false
    }
    this.formData.LanguageName = Cookies.get('language')?Cookies.get('language'):'zh-cn'
  }

  async mounted() {}

  private changeLanguage(lang: string) {
    this.formData.LanguageName = lang
    Cookies.set('language',lang)
    this.$i18n.locale = lang
    AppModule.SetLanguage(lang)
    document.documentElement.lang = lang
  }

  focusBlur(name:any,tips:any){
    let _ = this
    if(!this.formData[name]){
      this.wrong[tips] = true
    }
    else{
      this.wrong[tips] = false
    }
  }

  remeberPwd(val:any){
      if(val){
        if(this.formData.Account&&this.formData.Password){
          Cookies.set('loginPwd',this.formData.Password)
          Cookies.set('userName',this.formData.Account)
        }
        else{
          if(!this.formData.Account){
            this.wrong.userWrong = true
          }
          if(!this.formData.Password){
            this.wrong.pwdWrong = true
          }
          if(!this.formData.TenantName){
            this.wrong.tnWrong = true
          }
        }
      }
      else{
        Cookies.remove('loginPwd',this.formData.Password)
        Cookies.remove('userName',this.formData.Account)
        this.wrong.userWrong = false
        this.wrong.pwdWrong = false
        this.wrong.tnWrong = false
      }
  }

  async login(){
    if(this.formData.Account&&this.formData.Password){
      this.isLoading = true
      this.remeberPwd(this.formData.Remember)
      let data = await wt.Identity_PreLogin(this.formData)
      this.isLoading = false
      if('Success' in data){
        if(data['Success']){
          this.routeLink = this.$route.query.path?this.$route.query.path:''
          let routePath:any = ''
          if(this.routeLink.indexOf('?')){
            routePath = this.routeLink.split('?')[0]
          }
          else{
            routePath = this.routeLink
          }
          Cookies.set('loginName',this.formData.Account)
          Cookies.set('token',data['Data'])
          localStorage.setItem('loginData',JSON.stringify(this.formData))
          if(this.routeLink){
            this.$router.push({path:'/camp',query:{path:routePath}})
          }
          else{
            this.$router.push({path:'/camp'})
          }
        }
      }
    }
    else{
      this.remeberPwd(true)
    }
  }
}
